module.exports = __webpack_public_path__ + "static/logo-SMS-blanco-00720599b7c2238c29d98439a8913eea.png";